import {isFSA} from 'flux-standard-action'
import invariant from 'invariant'
import {
  LIBRARY_PROMO_CLOSE_RIGHT_COLUMN,
  LIBRARY_PROMO_HIDE_ASSIGN_OUTLET_MODAL,
  LIBRARY_PROMO_OPEN_RIGHT_COLUMN,
  LIBRARY_PROMO_SET_ACCORDION_ACTIVE_KEY,
  LIBRARY_PROMO_SET_CURRENT_PAGE,
  LIBRARY_PROMO_SET_DETAIL_PROMO,
  LIBRARY_PROMO_SET_INTERSECT_CATEGORIES,
  LIBRARY_PROMO_SET_INTERSECT_ITEMS,
  LIBRARY_PROMO_SET_INTERSECT_VARIANTS,
  LIBRARY_PROMO_SET_IS_SUBMITTED_EACH_PROMO_FORM,
  LIBRARY_PROMO_SET_IS_SUBMITTING_FORM,
  LIBRARY_PROMO_SET_LIST_PROMO,
  LIBRARY_PROMO_SET_OUTLETS,
  LIBRARY_PROMO_SET_PROMO_TYPES,
  LIBRARY_PROMO_SET_SELECTED_OUTLETS,
  LIBRARY_PROMO_SET_TOTAL_PAGE,
  LIBRARY_PROMO_SHOW_ASSIGN_OUTLET_MODAL,
  LIBRARY_PROMO_SET_DELETED_PROMO,
  LIBRARY_PROMO_SHOW_DELETE_MODAL,
  LIBRARY_PROMO_HIDE_DELETE_MODAL,
  LIBRARY_PROMO_SET_DEACTIVATED_PROMO,
  LIBRARY_PROMO_SHOW_DEACTIVATE_MODAL,
  LIBRARY_PROMO_HIDE_DEACTIVATE_MODAL,
  LIBRARY_PROMO_SET_REACTIVATED_PROMO,
  LIBRARY_PROMO_SHOW_REACTIVATE_MODAL,
  LIBRARY_PROMO_HIDE_REACTIVATE_MODAL,
  LIBRARY_PROMO_SHOW_CONFIRM_REACTIVATE_MODAL,
  LIBRARY_PROMO_HIDE_CONFIRM_REACTIVATE_MODAL,
  LIBRARY_PROMO_SET_PREV_ASSIGNED_OUTLETS,
  LIBRARY_PROMO_SHOW_UPDATE_CONFIRM_MODAL,
  LIBRARY_PROMO_HIDE_UPDATE_CONFIRM_MODAL,
  LIBRARY_PROMO_SET_NEXT_UPDATE_ACTION,
  LIBRARY_PROMO_SET_ACTION_UPDATE_NAME
} from 'actions/library/promo/constants'

let initialState = {
  openRightColumn: false,
  activeAccordion: '1',
  promoTypes: [],
  showAssignOutletModal: false,
  outlets: [],
  selectedOutlets: [],
  isSubmitPromoForm: {},
  items: [],
  categories: [],
  isSubmittingForm: false,
  variants: {},
  promos: [],
  currentPage: null,
  totalPage: null,
  detailPromo: null,
  showDeleteModal: false,
  deletedPromo: null,
  showDeactivateModal: false,
  deactivatedPromo: null,
  showReactivateModal: false,
  reactivatedPromo: null,
  showConfirmReactivateModal: false,
  previousAssignedOutlets: null,
  showUpdateConfirmModal: false,
  nextUpdateAction: null,
  actionUpdateName: ''
}

// Takes care of changing the application state
function reducer (state = initialState, action) {
  invariant(
    isFSA(action),
    `Invalid FSA action. See https://github.com/acdlite/flux-standard-action for info. Object: ${JSON.stringify(action)}`
  )

  let {type, payload} = action

  switch (type) {
    case LIBRARY_PROMO_OPEN_RIGHT_COLUMN:
      return {...state, openRightColumn: true}
    case LIBRARY_PROMO_CLOSE_RIGHT_COLUMN:
      return {...state, openRightColumn: false}
    case LIBRARY_PROMO_SET_ACCORDION_ACTIVE_KEY:
      return {...state, activeAccordion: String(payload.activeKey)}
    case LIBRARY_PROMO_SET_PROMO_TYPES:
      return {...state, promoTypes: payload.promoTypes}
    case LIBRARY_PROMO_SHOW_ASSIGN_OUTLET_MODAL:
      return {...state, showAssignOutletModal: true}
    case LIBRARY_PROMO_HIDE_ASSIGN_OUTLET_MODAL:
      return {...state, showAssignOutletModal: false}
    case LIBRARY_PROMO_SET_OUTLETS:
      return {...state, outlets: payload.outlets}
    case LIBRARY_PROMO_SET_SELECTED_OUTLETS:
      return {...state, selectedOutlets: payload.selectedOutlets}
    case LIBRARY_PROMO_SET_IS_SUBMITTED_EACH_PROMO_FORM:
      return {...state, isSubmitPromoForm: payload.newPromoForm}
    case LIBRARY_PROMO_SET_INTERSECT_ITEMS:
      return {...state, items: payload.items}
    case LIBRARY_PROMO_SET_INTERSECT_CATEGORIES:
      return {...state, categories: payload.categories}
    case LIBRARY_PROMO_SET_IS_SUBMITTING_FORM:
      return {...state, isSubmittingForm: payload.isSubmit}
    case LIBRARY_PROMO_SET_INTERSECT_VARIANTS:
      return {...state, variants: payload.variants}
    case LIBRARY_PROMO_SET_LIST_PROMO:
      return {...state, promos: payload.promos}
    case LIBRARY_PROMO_SET_DETAIL_PROMO:
      return {...state, detailPromo: payload.detailPromo}
    case LIBRARY_PROMO_SET_CURRENT_PAGE:
      return {...state, currentPage: payload.currentPage}
    case LIBRARY_PROMO_SET_TOTAL_PAGE:
      return {...state, totalPage: payload.totalPage}
    case LIBRARY_PROMO_SHOW_DELETE_MODAL:
      return {...state, showDeleteModal: true}
    case LIBRARY_PROMO_HIDE_DELETE_MODAL:
      return {...state, showDeleteModal: false}
    case LIBRARY_PROMO_SET_DELETED_PROMO:
      return {...state, deletedPromo: payload.deletedPromo}
    case LIBRARY_PROMO_SHOW_DEACTIVATE_MODAL:
      return {...state, showDeactivateModal: true}
    case LIBRARY_PROMO_HIDE_DEACTIVATE_MODAL:
      return {...state, showDeactivateModal: false}
    case LIBRARY_PROMO_SET_DEACTIVATED_PROMO:
      return {...state, deactivatedPromo: payload.deactivatedPromo}
    case LIBRARY_PROMO_SHOW_REACTIVATE_MODAL:
      return {...state, showReactivateModal: true}
    case LIBRARY_PROMO_HIDE_REACTIVATE_MODAL:
      return {...state, showReactivateModal: false}
    case LIBRARY_PROMO_SET_REACTIVATED_PROMO:
      return {...state, reactivatedPromo: payload.reactivatedPromo}
    case LIBRARY_PROMO_SHOW_CONFIRM_REACTIVATE_MODAL:
      return {...state, showConfirmReactivateModal: true}
    case LIBRARY_PROMO_HIDE_CONFIRM_REACTIVATE_MODAL:
      return {...state, showConfirmReactivateModal: false}
    case LIBRARY_PROMO_SET_PREV_ASSIGNED_OUTLETS:
      return {...state, previousAssignedOutlets: payload.prevAssignedOutlet}
    case LIBRARY_PROMO_SHOW_UPDATE_CONFIRM_MODAL:
      return {...state, showUpdateConfirmModal: true}
    case LIBRARY_PROMO_HIDE_UPDATE_CONFIRM_MODAL:
      return {...state, showUpdateConfirmModal: false}
    case LIBRARY_PROMO_SET_NEXT_UPDATE_ACTION:
      return {...state, nextUpdateAction: payload.nextUpdateAction}
    case LIBRARY_PROMO_SET_ACTION_UPDATE_NAME:
      return {...state, actionUpdateName: payload.actionUpdateName}
    default:
      return {...state}
  }
}

export default reducer



// WEBPACK FOOTER //
// ./app/reducers/library/promo.js